const FCFA_COUNTRY_CODES = ["BJ", "TD", "ML", "NE"];
const SHORT_PHONE_COUNTRY_CODES = ["BF", "TD", "ML", "NE", "SL"];

export function getCountryCode(countryInfo) {
  return countryInfo?.enName || "";
}

export function getCountryCurrencyCode(countryInfo, fallback = "") {
  const countryCode = getCountryCode(countryInfo);
  if (FCFA_COUNTRY_CODES.includes(countryCode)) {
    return "FCFA";
  }
  if (countryCode === "MZ") {
    return "MT";
  }
  if (countryCode === "SL") {
    return "SLE";
  }
  if (countryCode === "TH") {
    return "฿";
  }
  return countryInfo?.currencyCode || fallback;
}

export function applyCountryCurrencyCode(repaymentData) {
  const countryInfo = repaymentData?.configData?.countryInfoVO;
  if (!countryInfo) {
    return;
  }
  const currencyCode = getCountryCurrencyCode(countryInfo);
  if (currencyCode) {
    countryInfo.currencyCode = currencyCode;
  }
}

export function getPaymentPhoneMaxLength(countryInfo) {
  const countryCode = getCountryCode(countryInfo);
  if (countryCode === "EG") {
    return 11;
  }
  if (SHORT_PHONE_COUNTRY_CODES.includes(countryCode)) {
    return 9;
  }
  return 10;
}

export function zeroFillPaymentPhone(value, countryInfo) {
  value = (value || "").replace(" ", "");
  const countryCode = getCountryCode(countryInfo);
  if (countryCode === "SN") {
    if (value.startsWith("0")) {
      return value.substring(1);
    }
    return value;
  }
  if (/^\d+$/.test(value)) {
    if (countryCode === "EG") {
      if (value.length == 10 && value[0] != 0) {
        value = "0" + value;
      }
    } else if (value.length == 9 && value[0] != 0) {
      value = "0" + value;
    }
  }
  return value;
}

export function checkPaymentPhone(value, countryInfo) {
  value = (value || "").replace(" ", "");
  if (!/^\d+$/.test(value)) {
    return false;
  }
  const countryCode = getCountryCode(countryInfo);
  if (SHORT_PHONE_COUNTRY_CODES.includes(countryCode)) {
    return (value.length == 9 && value[0] == 0) || value.length == 8;
  }
  if (countryCode === "EG") {
    return (
      (value.length == 11 && value[0] == 0) ||
      (value.length == 10 && value[0] != 0)
    );
  }
  return (
    (value.length == 10 && value[0] == 0) ||
    (value.length == 9 && value[0] != 0)
  );
}

export function formatDecimalByPlaces(value, decimalPlaces) {
  if (decimalPlaces == null) {
    return value;
  }
  const places = Number(decimalPlaces);
  if (!Number.isInteger(places) || places < 0) {
    return value;
  }
  const str = String(value);
  const match = str.match(/^(-?)(\d*)(?:\.(\d*))?$/);
  if (!match) {
    return value;
  }
  const sign = match[1];
  const integerPart = match[2] || "0";
  let decimalPart = match[3] || "";
  if (places === 0) {
    return sign + integerPart;
  }
  if (decimalPart.length > places) {
    decimalPart = decimalPart.substring(0, places);
  } else {
    decimalPart = decimalPart.padEnd(places, "0");
  }
  return sign + integerPart + "." + decimalPart;
}

export function getMnoInfos(repaymentData) {
  return repaymentData?.configData?.checkoutConfigInfoVOList?.mnoInfos || [];
}

export function findMnoInfoByBankCode(repaymentData, bankCode) {
  if (bankCode == null) {
    return undefined;
  }
  return getMnoInfos(repaymentData).find(
    (v) => String(v?.bankInfoVO?.bankCode) === String(bankCode)
  );
}
